import types from './types.js'
import { clinicCity, cityDatagetFullLayTree } from '../../../api/utils/index'
import { outpatientFindStick } from '../../../api/template/template'
export default {
  namespaced: true,
  state: {
    ProvimceList: [],
    clitList: [],
    applyDrugDetail: {},
    activityFormLine: null //学术审批
  },
  mutations: {
    //获取省份
    [types.INIT_PROVIMCE] (state, data) {
      state.ProvimceList = data
    },
    // //获取市
    [types.INIT_CITY] (state, data) {
      state.clitList = data
    },

    [types.GET_APPLY_DETAIL] (state, data) {
      state.applyDrugDetail = data;
    },
    [types.ACTIVITY_FORM_LINE] (state, data) {
      state.activityFormLine = data;
    }
  },
  actions: {
    // 省份
    async [types.INIT_PROVIMCE] ({ commit }) {
      cityDatagetFullLayTree().then((res) => {
        if (res.code == 200) {
          const list = res.data || []
          commit(types.INIT_PROVIMCE, list)
        }
      })
    },
    // 市区
    async [types.INIT_CITY] ({ commit },) {
      clinicCity().then((res) => {
        if (res.code == 200) {
          const list = res.data || []
          commit(types.INIT_CITY, list)
        }
      })
    },
    async [types.GET_APPLY_DETAIL] ({ commit },) {
      const { code, data } = await outpatientFindStick()
      if (code == '000000') {
        commit(types.GET_APPLY_DETAIL, data)
      }
    },
    cacheActivityFormLine({commit},data) {
      commit(types.ACTIVITY_FORM_LINE, data)
    }
  },
  getters: {

  },
}



// WEBPACK FOOTER //
// ./src/store/modules/base/index.js